import axios from 'axios';
import { performGlobalLogout } from '../../state/utils/auth-utils';

// Set up an axios response interceptor to handle authentication errors
axios.interceptors.response.use(
  (response) => {
    const errorMessage = response?.data?.error?.message;

    // Check for JWT errors in successful responses (some APIs return error in data)
    if (
      response.data &&
      (errorMessage?.includes('JWT') ||
        errorMessage?.includes('invalid signature') ||
        errorMessage?.includes('token expired') ||
        errorMessage?.includes('unauthorized'))
    ) {
      console.log('JWT error detected in response data:', response.data.error);
      performGlobalLogout('/login');
    }

    // Return successful responses as is
    return response;
  },
  (error) => {
    console.log('Axios error intercepted:', error);

    const errorMessage = error?.response?.data?.error?.message;

    // Handle unauthorized errors (401)
    if (error.response && error.response.status === 401) {
      console.log('Session expired or unauthorized access detected');
      performGlobalLogout('/login');
    }

    // Also check for JWT errors in error response data
    if (
      error.response &&
      error.response.data &&
      (errorMessage?.includes('JWT') ||
        errorMessage?.includes('invalid signature') ||
        errorMessage?.includes('token expired') ||
        errorMessage?.includes('unauthorized'))
    ) {
      console.log('JWT error detected in error response:', errorMessage);
      performGlobalLogout('/login');
    }

    // Return the error for other processors
    return Promise.reject(error);
  }
);

// Export a function to initialize the interceptors
// This is just to ensure the file gets imported/executed
export function initAxiosInterceptors() {
  // Interceptors are already set up when this file is imported
  return true;
}
